export default __webpack_public_path__ + "static/media/PingFang-SC-Regular.628dc1b9.woff";